function zoom(e) {
    // Check if the event type is "mousedown" or "mousemove"
    if (e.type === "mousedown" || e.type === "mousemove") {
        var zoomer = e.currentTarget;
        const image = zoomer.querySelector('img')
        e.offsetX ? offsetX = e.offsetX : offsetX = e.touches[0].pageX
        e.offsetY ? offsetY = e.offsetY : offsetX = e.touches[0].pageX
        x = offsetX/zoomer.offsetWidth*100
        y = offsetY/zoomer.offsetHeight*100
 
        zoomer.style.backgroundImage = 'url(' + image.getAttribute('src') + ')'
        zoomer.style.backgroundPosition = x + '% ' + y + '%';

        image.style.opacity = 0;
    }
}
function zoomOut(e) {
    // Check if the event type is "mouseup"
    console.log(e.type)
    if (e.type === "mouseout") {
        var zoomer = e.currentTarget;
        const image = zoomer.querySelector('img')
        zoomer.style.removeProperty('background-image');
        image.style.opacity = 1;
    }
}


document.querySelectorAll('.product-tabs .tabs-nav__button').forEach(e=> {
    e.addEventListener('click', function() {
        // Remove the 'active' class from all '.product-tabs' elements
        document.querySelectorAll('.product-tabs .tabs-nav__button').forEach(tab => {
            tab.classList.remove('active');
        });
        // Add the 'active' class to the clicked element
        e.classList.add('active');
    });
});

let getSiblings = function (e) {
    // for collecting siblings
    let siblings = []; 
    // if no parent, return no sibling
    if(!e.parentNode) {
        return siblings;
    }
    // first child of the parent node
    let sibling  = e.parentNode.firstChild;
    
    // collecting siblings
    while (sibling) {
        if (sibling.nodeType === 1 && sibling !== e) {
            siblings.push(sibling); 
        }
        sibling = sibling.nextSibling;
    }
    return siblings;
};

var tab_buttons = document.querySelectorAll('.tab-title')

tab_buttons.forEach( el=> {
    el.addEventListener('click', (e)=> {
        var id = e.currentTarget.dataset.index;

        var tab_items = document.querySelectorAll('[data-blocknum]')

        let siblings = getSiblings(e.currentTarget);

        siblings.forEach(m=> {
            m.classList.remove('active')
        })

        e.currentTarget.classList.add('active')

        tab_items.forEach( u=> {

            if ( u.dataset.blocknum == id ) {
                u.classList.remove('hidden-item')
                u.classList.add('active-tab')
            } else { 
                u.classList.add('hidden-item')
                u.classList.remove('active-tab')
            }
        })
        var last = document.querySelectorAll('[data-blocknum].active-tab')
        last[last.length - 1].classList.add('last-el')
    })
})

if ( tab_buttons.length > 0 ) {
    tab_buttons[0].click();
}

const stickyBanner = document.querySelectorAll(".sticky-banner")

stickyBanner.forEach(el=> {
    const observer = new IntersectionObserver( 
        ([e]) => e.target.classList.toggle("is-pinned", e.intersectionRatio < 1),
        { threshold: [1] }
    );
      
    observer.observe(el);
})
